import { Helmet } from "react-helmet";

import PageLayout from "components/layouts/PageLayout";

import LoanPackagesTable from "./LoanPackagesTable";
import { useLoanPackagesFilter } from "./LoanPackagesTable/useLoanPackagesFilter";

const LoanPackagesPage = () => {
  const { filters, searchField } = useLoanPackagesFilter();

  return (
    <>
      <Helmet title="Loan Packages" />
      <PageLayout
        title="Loan Packages List"
        subtitle="View and manage loan packages and applications."
        search={{
          value: searchField.value,
          onChange: searchField.onChange,
          placeholder: "Search by customer name",
        }}
      >
        <LoanPackagesTable filters={filters} />
      </PageLayout>
    </>
  );
};

export default LoanPackagesPage;
